import React from 'react'
import { Select, MenuItem, FormControl } from '@material-ui/core'
import { Field } from 'react-formality'
import PropTypes from 'prop-types'
import that from '../../utilities/translationHelper'

const MassUnitField = ({ name, value, onChange, onBlur }) => (
	<Field
		supportsHelperText={false}
		component={FormControl}
		name={name}
		validate={{
			presence: true
		}}
	>
		<Select
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			disableUnderline
		>
			<MenuItem value="kg">{that.context.translate('kg')}</MenuItem>
			<MenuItem value="lb">{that.context.translate('lb')}</MenuItem>
		</Select>
	</Field>
)

MassUnitField.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func.isRequired
}

MassUnitField.defaultProps = {
	value: undefined
}

export default MassUnitField



// WEBPACK FOOTER //
// ./src/components/Edit/MassUnitField.jsx